import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import media from '../../utils/Breakpoints';
import { fonts, colors } from '../../utils/config';

import Icon from './icon';

const StyledMenuItem = styled.div`
	flex: 0 1 16.66666%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	height: 72px;
	width: 56px;
	text-align: center;
	user-select: none;

	&:hover {
		cursor: pointer;
	}

	&:hover {
		svg path {
			fill: #fff;
		}
	}

	${media.lg`
		height: 96px;
		width: 76px;
	`}

	&[data-icon='alle'] {
		div {
			background-color: ${props => (props.active ? `${colors.cyandark}` : `${colors.graylight}`)};
		}

		&:hover div {
			background-color: ${colors.cyandark};
		}
	}

	&[data-icon='mehr'] {
		div {
			background-color: ${props => (props.active ? `${colors.cyandark}` : `${colors.graylight}`)};
		}

		&:hover div {
			background-color: ${colors.cyandark};
		}
	}

	&[data-icon='regiorad'] {
		div {
			background-color: ${props => (props.active ? '#06507F' : `${colors.graylight}`)};
		}

		&:hover div {
			background-color: #06507f;
		}
	}

	&[data-icon='stella'] {
		div {
			background-color: ${props => (props.active ? '#E32E20' : `${colors.graylight}`)};
		}

		&:hover div {
			background-color: #E32E20;
		}
	}

	&[data-icon='stadtmobil'] {
		div {
			background-color: ${props => (props.active ? '#E2000F' : `${colors.graylight}`)};
		}

		&:hover div {
			background-color: #e2000f;
		}
	}

	&[data-icon='car2go'],
	&[data-icon='sharenow'] {
		div {
			background-color: ${props => (props.active ? '#1498E3' : `${colors.graylight}`)};
		}

		&:hover div {
			background-color: #1498e3;
		}
	}

	&[data-icon='bolt'] {
		div {
			background-color: ${props => (props.active ? '#32BB78' : `${colors.graylight}`)};
		}

		&:hover div {
			background-color: #32BB78;
		}
	}
	&[data-icon='voi'] {
		div {
			background-color: ${props => (props.active ? '#F46C63' : `${colors.graylight}`)};
		}

		&:hover div {
			background-color: #F46C63;
		}
	}
	&[data-icon='zeus'] {
		div {
			background: ${props =>
			props.active
				? 'linear-gradient(135deg, rgb(251, 123, 30) 0%, rgb(251, 123, 30) 26%, rgb(250, 96, 29) 64%, rgb(247, 24, 24) 100%)'
				: `${colors.graylight}`};
		}

		&:hover div {
			background: linear-gradient(
				135deg,
				rgb(251, 123, 30) 0%,
				rgb(251, 123, 30) 26%,
				rgb(250, 96, 29) 64%,
				rgb(247, 24, 24) 100%
			);
		}
	}
	&[data-icon='nextbike'] {
		div {
			background-color: ${props => (props.active ? '#0154A6' : `${colors.graylight}`)};
		}

		&:hover div {
			background-color: #0154A6;
		}
	}
	&[data-icon='lime'] {
		div {
			background-color: ${props => (props.active ? '#23D000' : `${colors.graylight}`)};
		}

		&:hover div {
			background-color: #23D000;
		}
	}
	&[data-icon='deer'] {
		div {
			background-color: ${props => (props.active ? 'black' : `${colors.graylight}`)};
		}

		&:hover div {
			background-color: black;
		}
	}
	&[data-icon='dott'] {
		div {
			background-color: ${props => (props.active ? '#009DDB' : `${colors.graylight}`)};
		}

		&:hover div {
			background-color: #009DDB;
		}
	}

	&[data-icon='ökostadtrenningen'] {
		div {
			background: ${props =>
				props.active
					? 'linear-gradient(to bottom, rgb(252,193,7), rgb(232,88,13))'
					: `${colors.graylight}`};
		}

		&:hover div {
			background: linear-gradient(to bottom, rgb(252,193,7), rgb(232,88,13));
		}
	}
	&[data-icon='free2move'] {
		div {
			background:  ${props => (props.active ? '#1E0046' : `${colors.graylight}`)};
		}

		&:hover div {
			background: #1E0046;
		}
	}

	&[data-icon='flinkster'] {
		div {
			background-color: ${props => (props.active ? '#E2000F' : `${colors.graylight}`)};
		}

		&:hover div {
			background-color: #e2000f;
		}
	}

	&[data-icon='rbahn']:hover svg path {
		fill: ${colors.grayblue};
	}
	${props =>
		props.active
			? `
			&[data-icon='rbahn'] svg path {
				fill: ${colors.grayblue};
			}`
			: ''}

	&[data-icon='sbahn']:hover svg path {
		fill: #52b331;
	}
	${props =>
		props.active
			? `
			&[data-icon='sbahn'] svg path {
				fill: #52b331;
			}`
			: ''}

	&[data-icon='ubahn']:hover svg path {
		fill: #0aa1e2;
	}
	${props =>
		props.active
			? `
			&[data-icon='ubahn'] svg path {
				fill: #0aa1e2;
			}`
			: ''}

	&[data-icon='bus']:hover svg path {
		fill: #c31924;
	}
	${props =>
		props.active
			? `
			&[data-icon='bus'] svg path {
				fill: #c31924;
			}`
			: ''}

	${props =>
		props.type === 'places' &&
		`
		&:hover div {
			background-color: ${colors.orange};
		}
	`}

	${props =>
		props.type === 'places' &&
		props.active &&
		`
		div {
			background-color: ${colors.orange};
		}
	`}
`;

const Title = styled.h2`
	height: ${props => (props.type === 'sharing' ? 'auto' : '24px')};
	margin-top: 4px;
	font-size: 12px;
	line-height: 1;
	font-family: ${fonts.default};
	font-weight: normal;
	color: ${colors.black};
`;

export default function MenuItem({ title, titlefilter, icon, type, active, onClick }) {
	return (
		<StyledMenuItem
			active={active}
			type={type}
			data-icon={icon}
			onClick={onClick}
			titlefilter={titlefilter}
		>
			<Icon icon={icon} type={type} active={active} />
			<Title type={type}>{title}</Title>
		</StyledMenuItem>
	);
}

MenuItem.propTypes = {
	icon: PropTypes.oneOf([
		'alle',
		'freizeit',
		'essentrinken',
		'kultur',
		'sehenswuerdigkeiten',
		'rundumsrad',
		'bildungseinrichtungen',
		'krankenhaeuserkliniken',
		'verbaendevereine',
		'mehr',
		'stella',
		'car2go',
		'sharenow',
		'flinkster',
		'regiorad',
		'stadtmobil',
		'nextbike',
		'voi',
		'bolt',
		'deer',
		'dott',
		'lime',
		'zeus',
		'ökostadtrenningen',
		'free2move',
		'rbahn',
		'sbahn',
		'ubahn',
		'bus',
	]).isRequired,
	title: PropTypes.string.isRequired,
	titlefilter: PropTypes.string,
	type: PropTypes.string,
	active: PropTypes.bool,
	onClick: PropTypes.func,
};
